import { render, staticRenderFns } from "./PasswordResetFinish.vue?vue&type=template&id=51f2084b&scoped=true&"
import script from "./PasswordResetFinish.vue?vue&type=script&lang=js&"
export * from "./PasswordResetFinish.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetFinish.vue?vue&type=style&index=0&id=51f2084b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f2084b",
  null
  
)

export default component.exports